/*
  collection.js — la page des kits et toutes les collections (section
  main-collection), module chargé par la section :
  <script type="module" src="{{ 'collection.js' | asset_url }}">.
  S'enregistre auprès du système par DRAYKI.section('kits', init) : lancé au
  démarrage de drayki.js, puis à chaque rechargement de la section dans
  l'éditeur de thème (shopify:section:load, la section en racine).

  Porte le <script> de kits.html (maquette r7) :
    source  scratchpad/site/kits.html, lignes 368-774
    mtime   2026-09-27 01:41:34 (+02:00), 52 549 octets
    sha256  4e4179a6cd594298901a05eb4c3563d37c805e11b99082406dbaba24f69de17f (kits.html entier)
    base    work/sync/collection.js.base (la copie d'origine, pour la fusion à trois)
  Chaque retouche faite pour le thème est marquée « THEME: » ; le reste suit la
  maquette (ses commentaires en anglais compris).

  Ce qui change avec Shopify (THEME:) :
  - les cartes sont rendues par Liquid (snippet kit-card) : plus de ITEMS écrits
    depuis D.KITS ; la table les lit dans la page (.item[data-type], leur id =
    le handle) ;
  - le filtre et le tri gardent arrange() / relay() (la table couchée puis
    relevée sur place), avec les vrais paramètres de Shopify dans l'adresse
    (?filter.p.product_type=DRUMKIT, ?sort_by=price-ascending), tenue à jour par
    history.replaceState ; ils ne se font sur place que si toute la sélection
    est dans la page (data-k-whole) — sinon les liens chargent la page filtrée
    par Shopify (Search & Discovery) ;
  - le tri lit le prix (centimes) et la date de création dans le catalogue
    (DRAYKI.catalog), sinon dans le petit JSON de la section (data-k-sort) ;
  - « get the vault » (data-vault-add) est au système (drayki.js), plus ici ;
  - un kit pressé ouvre sa page (chaque kit en a une) : plus de demi-tour sur
    place ;
  - la carte 0 % de la bande prend l'autre palette (data-other, imprimé par le
    snippet promises) : posée tout de suite quand l'éditeur recharge la section ;
  - l'éditeur : l'instance précédente est lâchée (écouteurs, minuteurs, effets)
    quand la section est rechargée ou retirée.
*/
/*
  kits.html — the page's own behaviour, on the system (site.js):
  1. the shelf: every kit written as the system's card (before site.js
     mounts the page), then laid out in the order asked — filter and sort,
     read from the address (?filter.p.product_type=, ?sort_by=; the old
     #type too); in "all" halo sits between the shelves (after the first
     four kits), under a filter's kits it follows them; the bundles are
     the table's foot. The table read off the scroll (r7): each kit's pose
     and hairline, halo's slab (the system's objects, their layPose).
     Re-laying the table: the kits in
     view lie down where they are (obj.lie), the new set is laid out, each
     stands up in reading order. A kit named in the link is brought to the
     eye (obj.present); #vault, to the vault's bundle. A kit pressed here
     turns round to its back at once (machina, which has its page, opens it).
  2. the vault's key, in the bundles (every kit into the cart in one go,
     the cart opened).
  Everything that moves runs in the system's one loop, only while it moves.
  In Liquid: the items are the section's loop over collection.products (the
  kit card snippet).
*/
const D = window.DRAYKI;
const W = window, doc = document;
const $ = (s, r = doc) => r.querySelector(s);
const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
// the address: Shopify's own filter and sort parameters
const QF = 'filter.p.product_type', QS = 'sort_by';
const SORTS = { new: 'created-descending', price: 'price-ascending' };

// THEME: the running page (one at a time: the theme editor re-renders the
// section, the one before is let go — its listeners, timers and effects)
let live = null;

function init(scope) {
  // THEME: the table of this section (scope: the document at the start, a
  // section's wrapper when the editor re-renders one — another section's
  // reload leaves the table as it is)
  const board = $('#board.k-board[data-k-band]', scope === doc ? doc : scope);
  if (!board || board === (live && live.board)) return;
  if (live) live.stop();
  const sec = board.closest('.shopify-section') || board.parentNode || doc;
  const ctl = 'AbortController' in W ? new AbortController() : null;
  const on = ctl ? { signal: ctl.signal } : undefined;
  const timers = new Set();
  const later = (f, ms) => { const t = setTimeout(() => { timers.delete(t); f(); }, ms); timers.add(t); return t; };
  const effects = [];
  let arrangeT = 0;
  const me = {
    board,
    stop() {
      if (ctl) ctl.abort();
      timers.forEach(clearTimeout); timers.clear();
      clearTimeout(arrangeT);
      effects.forEach((f) => { try { D.unregister(f); } catch (e) { /* gone with its section */ } });
      if (live === me) live = null;
    },
  };
  live = me;
  // (the section taken out in the editor: its page goes with it)
  doc.addEventListener('shopify:section:unload', (e) => { if (e.target && e.target.contains && e.target.contains(board)) me.stop(); }, on);

  const E = D.engine;
  const ON = !!E.on;
  const objOf = (el) => { const k = $('.kit', el); return k && k._obj; };

  // THEME: the cards are Liquid's (the kit card snippet, id = the handle);
  // their order in the page is the server's (the order asked in the address)
  const ITEMS = $$('.item', board);
  const hOf = (el) => { const k = $('.kit', el); return (k && k.dataset.kit) || el.id; };
  const byH = new Map(ITEMS.map((el) => [hOf(el), el]));
  const AT = new Map(ITEMS.map((el, i) => [el, i]));
  // THEME: price (cents) and date for the sort: the catalogue first
  // (drayki-catalog, the kits of the kits collection), else the section's
  // own JSON (every product of the page)
  const LOCAL = (() => { try { const s = $('script[data-k-sort]', sec); return s ? JSON.parse(s.textContent) : {}; } catch (e) { return {}; } })();
  const ENTRY = new Map();
  const entry = (el) => {
    const h = hOf(el);
    if (ENTRY.has(h)) return ENTRY.get(h);
    const c = D.catalog && typeof D.catalog.get === 'function' ? D.catalog.get(h) : null, l = LOCAL[h];
    const r = { price: c && c.price != null ? +c.price : l ? +l[0] : 0, created: c && c.created != null ? +c.created : l ? +l[1] : 0 };
    ENTRY.set(h, r);
    return r;
  };
  const price = (el) => entry(el).price;
  const created = (el) => entry(el).created;
  // THEME: the types of the index (their keys, and the real product types
  // Shopify filters on: data-f="808" data-v="808 LIBRARY")
  const FLINKS = $$('[data-f]', sec), SLINKS = $$('[data-sort]', sec);
  const VAL = {};
  FLINKS.forEach((a) => { if (a.dataset.f !== 'all') VAL[a.dataset.f] = a.dataset.v || a.dataset.f; });
  const TYPES = Object.keys(VAL);
  // THEME: what can be re-laid here without a new page: the whole
  // selection is in the page (one page, not filtered by Shopify) — filter
  // and sort; one page filtered by Shopify — the sort only; several pages —
  // neither (the links load the page asked)
  const WHOLE = board.dataset.kWhole || '';
  const canF = WHOLE === 'all', canS = WHOLE === 'all' || WHOLE === 'sort';
  // THEME: the collection's own order (the admin's); a sort that is the
  // collection's own needs no parameter
  const DEF = board.dataset.kDefault || '';
  const BAND = Math.max(0, parseInt(board.dataset.kBand, 10) || 0);
  const sortOf = (v) => (v === SORTS.price ? 'price' : v === SORTS.new ? 'new' : '');
  const query = (f, s) => {
    const q = new URLSearchParams(location.search);
    q.delete(QF); q.delete(QS); q.delete('page');
    if (f !== 'all' && VAL[f]) q.set(QF, VAL[f]);
    const v = SORTS[s];
    if (v && v !== DEF) q.set(QS, v);
    const t = q.toString();
    return t ? `?${t}` : '';
  };
  const hrefOf = (f, s) => location.pathname + query(f, s);

  /* ---------------------------------------------------- 1. the items */
  const shelves = $$('[data-chunk]', board);
  const bento = $('[data-bento]', board);

  // THEME: the 0 % card in the other palette (kits.html: data-other, printed
  // by the promises snippet): the night key on paper, paper on violet night.
  // The system turns it with the page; a section the editor has just
  // re-rendered comes with the server's palette: set now
  for (const rf of $$('.k-facts > .rf', board)) {
    rf.setAttribute('data-other', '');
    rf.setAttribute('data-theme', doc.documentElement.getAttribute('data-theme') === 'night' ? 'paper' : 'night');
  }

  /* ---------------------------------------------- #vault (the bundles) */
  // #vault (the home's "go all in" and its ticker, the cart's "open the
  // vault"): the vault's bundle brought to the eye, the cart closed
  // first; its stack sets itself down as it arrives, as anywhere
  // THEME: looked up when asked (the bundles are another section: the
  // editor may re-render it); the full bundles' vault is #bv
  const vaultEl = () => doc.getElementById('vault') || doc.getElementById('bv');
  function toVault(smooth) {
    const v = vaultEl();
    if (!v) return;
    if (W.closeCartDrawer) W.closeCartDrawer();
    v.scrollIntoView({ block: 'center', behavior: smooth && ON ? 'smooth' : 'auto' });
  }
  // (a link to it from this page — the cart's, pressed twice too — never
  // leaves the page, nor the filter asked for)
  doc.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const u = new URL(a.href, location.href);
    if (u.hash !== '#vault' || u.pathname !== location.pathname || !vaultEl()) return;
    e.preventDefault();
    if (location.hash !== '#vault') { try { history.pushState(null, '', location.pathname + location.search + '#vault'); } catch (err) { /* sandboxed */ } }
    toVault(true);
  }, on);
  // THEME: an empty table (no kit shown): only the vault's links
  if (!ITEMS.length || !shelves.length) {
    if (location.hash === '#vault') later(() => toVault(false), 120);
    return;
  }

  /* ---------------------------- the table read off the scroll (r7) */
  // drayki: "ça manque de scrolling animations sur la page kits". One
  // law for every kit on the table, read off the scroll both ways, still
  // at rest (the system's one loop, only while the page moves):
  // - coming up the screen it lies back and stands up by the middle (the
  //   system's card arrival, as before), and its hairline is drawn from
  //   the left under it as it stands (--kq): a row comes in as a wave,
  //   each object and its line together. The line is drawn once (the
  //   system's Once, as a drawing: finished on its own clock at rest,
  //   never taken back — never half a line left on a still page); the
  //   first screen's kits have theirs from the start;
  // - going on up past the middle, it turns on a little (ten degrees
  //   further round, a little less tipped back): the eye going down the
  //   table. From the foot of the screen to its top a kit turns one way,
  //   in one move; it stands at its reading pose at the middle.
  // HALO's slab, in its card, turns as it passes: its other side as it
  // comes up, its reading pose at the middle, a little further round as
  // it goes (less on a wide screen: the slab is larger there).
  // THE WAVE (r7): the system has a card of a row stand up a little later
  // the further right it stands (its lag, a tenth of a screen across a
  // row), but only by ending later — every card of a row began at the
  // same place, so a row lay back, stood up and turned as one piece. On
  // this page every move of a kit (lying back, standing up, its line,
  // turning on) is read on the kit as if it stood further down the
  // screen by its own lag, larger (a fifth of a screen across a laptop's
  // row, .14 across a phone's) and counted from the row's middle (the
  // left of a row a little earlier than the system's, the right a little
  // later): the row's one curve moved along from left to right, never
  // squeezed — the row ripples from its left, each object and its line
  // together; the first screen's row stands, and a row still stands by
  // the middle. The system's lag is left as it is (the other pages).
  // The page's own moments, on the system's object (its layPose, per
  // object) and its Once: nothing of the system is changed. Reduced
  // motion: the objects never lay (their pose, still), the lines are whole.
  const sm = (u) => u * u * (3 - 2 * u), cl = (x) => (x < 0 ? 0 : x > 1 ? 1 : x);
  const layBase = D.Obj.prototype.layPose;
  // (a kit's lag here, in screens, from where its middle stands across the
  // screen — below zero left of the middle; read at layout only)
  const lagOf = (r) => (E.vw > 1100 ? .2 : .14) * (cl((r.left + r.width / 2) / (E.vw || 1)) - .5);
  function kitPose() {
    const d = (this.klag || 0) * E.vh;
    // (the system's arrival, read on the kit placed d further down: its whole curve moved, never stretched)
    const p = layBase.call(Object.create(this, { top: { value: this.top + d }, lag: { value: 0 } }));
    const at = E.vw > 1100 ? .6 : .5, cy = this.top + d + this.h * .5 - E.S;
    const x = cl((E.vh * at - cy) / (E.vh * at + this.h * .25));
    if (!x) return p;
    const e = sm(x);
    return { rx: p.rx - 12 * e, ry: p.ry - 10 * e, rz: p.rz };
  }
  function haloPose() {
    const c = (this.top + this.h * .5 - E.S) / E.vh, r = this.rest, a = E.vw > 1100 ? .7 : 1, span = .5 + this.h * .5 / E.vh;
    if (c >= .5) { const e = sm(cl((c - .5) / span)) * a; return { rx: r.rx + 14 * e, ry: r.ry + 28 * e, rz: r.rz - 3 * e }; }
    const e = sm(cl((.5 - c) / span)) * a;
    return { rx: r.rx - 8 * e, ry: r.ry - 16 * e, rz: r.rz + e };
  }
  const poseNow = (o) => { if (!o || !o.lay || o.la) return; const p = o.flat(o.layPose(), o.lk); o.lastT = ''; o.write(p.rx, p.ry, p.rz); };
  // (a kit's line: drawn from where its caption stands on the screen as
  // its object stands up — the object's middle at the middle of the
  // screen, 60 % on a computer, later by its lag to the right of a row —
  // to three tenths of a screen before; re-read at every layout)
  function lineFrom(el, L) {
    const k = $('.kit', el), kr = k && k.getBoundingClientRect(), cr = L.el.getBoundingClientRect();
    if (!kr || !kr.height) return;
    const b = (E.vw > 1100 ? .6 : .5) - lagOf(kr) + (cr.top - (kr.top + kr.height / 2)) / E.vh;
    L.b = b; L.a = Math.min(.99, b + .3);
  }
  function lineIn(el) {
    const c = $('.capt', el);
    if (!c || el._line) return;
    c.style.setProperty('--kq', '0');
    const L = new D.Once(c, (p) => { if (p >= 1) c.style.removeProperty('--kq'); else c.style.setProperty('--kq', sm(p).toFixed(3)); }, .5);
    const lay = L.layout;
    L.layout = function () { lay.call(this); lineFrom(el, this); };
    el._line = D.register(L, c);
  }
  // (the rest, made sure of — for site.js, reported) At rest the system
  // finishes on their own clocks the arrivals already under way; "under
  // way" is read on its follower of the scroll, which lags the page when
  // frames come slowly (a phone busy decoding covers, headless Edge at
  // 2x): a stack, a word, a figure, a line due where the page stopped but
  // not yet begun on the follower was left half set down, half uncovered,
  // still ("−2" of "−20 %", one tile of two). Here, at rest, whatever is
  // due where the page has actually stopped is finished too, on its own
  // clock. Nothing runs for it in between (a frame that does nothing).
  if (ON) {
    const due = (x, a, b) => cl((x - a) / (b - a)) > 0;
    const go = (f) => { f.fin = true; f.hot = true; };
    // THEME: kept to be let go with the page (registered without an element)
    const rest = { always: true, frame: () => false, settle() {
      for (const f of E.fx) {
        if (f.dead || !f.seen || f.fin || f.done || f.top == null) continue;
        if (f instanceof D.Stack) { if (due((f.top + f.h / 2 - E.Y) / E.vh, f.qa, f.qb)) go(f); }
        else if (f instanceof D.Once) { if (due((f.top - E.Y) / E.vh, f.a, f.b)) go(f); }
        else if ('kind' in f && 'host' in f && f.p < 1) { if (due((f.top - E.Y) / E.vh, .92, .42)) go(f); }   // (a curtain)
      }
    } };
    D.register(rest);
    effects.push(rest);
  }
  // (the kits a re-laid table brings into view: their lines with their captions, at once)
  const lineDone = (el) => { const L = el._line; if (!L || L.done) return; L.p = 1; L.w(1); L.done = true; D.unregister(L); };
  if (ON) {
    ITEMS.forEach((el) => {
      const o = objOf(el);
      if (!o || !o.lay) return;
      o.layPose = kitPose;
      // (its lag here, re-read with its place at every layout; a hidden kit has none)
      const lay = o.layout;
      o.layout = function () { lay.call(this); const r = this.el.getBoundingClientRect(); this.klag = r.width ? lagOf(r) : 0; };
    });
    const hk = $('[data-k-pass]', board), ho = hk && hk._obj;
    if (ho && ho.lay) ho.layPose = haloPose;
  }

  /* ---------------------------------------------- the table: order */
  // THEME: F, a type's key ('all'); S, the sort ('new', 'price', or '' —
  // the collection's own order); S0, the order the page came in (the
  // server's): shown as it is, never re-sorted — but for the price, always
  // sorted here by the price shown (see fromURL)
  let F = 'all', S = '', S0 = '';
  const cols = () => { const t = getComputedStyle(shelves[0]).gridTemplateColumns; const c = t && t !== 'none' ? t.split(' ').length : 4; return c || 4; };
  const current = () => {
    let ks = ITEMS.filter((el) => F === 'all' || el.dataset.type === F);
    // THEME: the order the page came in stands for its own sort; another is
    // sorted here (a price, then a date — the newest first — the page's order
    // between equals)
    if (S !== S0) {
      if (S === 'price') ks = ks.slice().sort((a, b) => price(a) - price(b) || AT.get(a) - AT.get(b));
      else if (S === 'new') ks = ks.slice().sort((a, b) => created(b) - created(a) || AT.get(a) - AT.get(b));
    }
    return ks;
  };
  const nEl = $('[data-k-n]', sec), wEl = $('[data-k-w]', sec), minEl = $('[data-k-min]', sec);
  let lastCols = 0;
  // the index and the count answer the finger at once; the table follows
  function mark() {
    const vis = current();
    // THEME: the count and the lowest price are the page's own only where the
    // whole selection is here (several pages: Liquid's figures, for them all)
    if (canS) {
      if (nEl) nEl.textContent = vis.length;
      // (the words come from the theme's texts, collection.count, printed by
      // the section: data-k-one / data-k-many — never data-other, the
      // system's band in the other palette)
      if (wEl) wEl.textContent = (vis.length === 1 ? wEl.dataset.kOne : wEl.dataset.kMany) || wEl.textContent;
      if (minEl && vis.length && D.fmt) minEl.textContent = D.fmt(Math.min(...vis.map(price)));
    }
    FLINKS.forEach((a) => { const on = a.dataset.f === F; a.classList.toggle('on', on); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); a.href = hrefOf(a.dataset.f, S); });
    SLINKS.forEach((a) => { const on = a.dataset.sort === S; a.classList.toggle('on', on); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); a.href = hrefOf(F, a.dataset.sort); });
    showOn(mark.done && ON);
    mark.done = true;
  }
  // (on a phone the filters are a row that swipes: the one chosen is
  // brought whole into the row, with the dot before it)
  function showOn(smooth) {
    const row = $('[data-filters]', sec), on = row && $('[data-f].on', row);
    if (!on || row.scrollWidth <= row.clientWidth + 1) return;
    const rr = row.getBoundingClientRect(), ar = on.getBoundingClientRect(), pad = parseFloat(getComputedStyle(row).paddingLeft) || 0;
    const dot = on.previousElementSibling, dl = dot && dot.classList.contains('dot') ? dot.getBoundingClientRect().left : ar.left;
    if (ar.left < rr.left + pad - 1 || ar.right > rr.right - pad + 1) row.scrollTo({ left: Math.max(0, row.scrollLeft + (on.dataset.f === 'all' ? ar.left : dl) - rr.left - pad), behavior: smooth ? 'smooth' : 'auto' });
  }
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(() => { if (live === me) showOn(false); });
  function arrange() {
    const vis = current(), set = new Set(vis);
    // (in "all": the first four kits — a laptop's first row, a phone's
    // first two — then halo and the promises, then the rest. A filter:
    // its kits together, halo under them. The bundles are the table's
    // foot, whatever is asked)
    // THEME: as many as the section asks before the band (its setting),
    // made whole rows; no band, one shelf. Fewer kits than two such runs
    // (featured's five, kontakt's one): the band after them all — never a
    // lone kit and its empty places under the band (as the section does)
    const c = cols();
    let per = F === 'all' && bento && BAND ? Math.max(c, Math.ceil(BAND / c) * c) : Infinity;
    if (vis.length < per * 2) per = Infinity;
    const s0 = shelves[0], s1 = shelves[1] || shelves[0];
    vis.forEach((el, i) => { el.hidden = false; (i < per ? s0 : s1).appendChild(el); });
    ITEMS.forEach((el) => { if (!set.has(el)) { el.hidden = true; s1.appendChild(el); } });
    shelves.forEach((s) => { s.hidden = !s.querySelector('.item:not([hidden])'); });
    mark();
    lastCols = c;
  }
  // (a kit that was hidden has not fetched its cover yet: the first ones
  // of the new set fetch theirs while the table is cleared)
  const prime = (list) => list.forEach((el) => { for (const i of $$('img', el)) if (i.loading === 'lazy') i.loading = 'eager'; });
  const ready = (list, ms) => {
    const imgs = [];
    list.forEach((el) => { for (const i of $$('img', el)) if (!i.complete) imgs.push(i); });
    if (!imgs.length) return Promise.resolve();
    return Promise.race([Promise.all(imgs.map((i) => (i.decode ? i.decode().catch(() => {}) : Promise.resolve()))), new Promise((r) => later(r, ms))]);
  };

  /* ------------------------- the table re-laid: down, then up again */
  const T_OUT = 180, T_IN = 600, GAP_IN = 40, GAP_CAP = 5;
  const inView = (el) => { const r = el.getBoundingClientRect(); return r.height > 0 && r.bottom > 0 && r.top < E.vh; };
  // THEME: the add key is in its form (kit-card: a real /cart/add without the
  // script; the form is display: contents, so the key itself is faded)
  const parts = (el) => [$('.capt', el), $(':scope > .btn, :scope > form > .btn', el)].filter(Boolean);
  const fade = (el, to, delay) => {
    for (const c of parts(el)) {
      if (!c.animate) continue;
      if (c._fa) { c._fa.cancel(); c._fa = null; }
      c._fa = c.animate(to ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }],
        { duration: to ? 320 : 140, delay, fill: to ? 'backwards' : 'forwards', easing: 'cubic-bezier(.2,.7,.2,1)' });
    }
  };
  let relaying = false, again = false;
  function relay() {
    // THEME: (no kit turned round here: each opens its page)
    if (!ON) { arrange(); D.layout(); return; }
    if (relaying) { again = true; return; }
    relaying = true;
    const shown = ITEMS.filter((el) => !el.hidden && inView(el));
    shown.forEach((el, i) => { const o = objOf(el); if (o) o.lie(1, T_OUT, i * 10); fade(el, 0, i * 10); });
    prime(current().slice(0, Math.max(8, cols() * 3)));
    later(() => {
      again = false;
      arrange();
      ITEMS.forEach((el) => parts(el).forEach((c) => { if (c._fa) { c._fa.cancel(); c._fa = null; } }));
      D.layout();
      const next = ITEMS.filter((el) => !el.hidden && inView(el)).sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
      const nset = new Set(next);
      next.forEach(lineDone);
      ITEMS.forEach((el) => { const o = objOf(el); if (o && !nset.has(el) && (o.lk || o.la)) o.lie(0); });
      // (they wait flat until their covers are there — at once when they are)
      next.forEach((el) => { const o = objOf(el); if (o) o.lie(1); parts(el).forEach((c) => { c.style.opacity = '0'; }); });
      ready(next, 300).then(() => {
        if (live !== me) return;
        next.forEach((el, i) => {
          parts(el).forEach((c) => { c.style.opacity = ''; });
          const d = Math.min(i, GAP_CAP) * GAP_IN, o = objOf(el);
          if (o) o.lie(0, T_IN, d);
          fade(el, 1, d + T_IN * .3);
        });
        relaying = false;
        if (again) { again = false; relay(); }
      });
    }, T_OUT + 20 + shown.length * 10);
  }
  // THEME: the real parameters (and the others of the address kept)
  const keepURL = () => { try { history.replaceState(history.state, '', hrefOf(F, S)); } catch (e) { /* sandboxed */ } };
  function setFilter(f) { if (f === F) return; F = f; mark(); relay(); keepURL(); }
  function setSort(s) { if (s === S) return; S = s; mark(); relay(); keepURL(); }
  // THEME: on the page only where the whole selection is here; else the
  // link loads the page Shopify filters (a new tab, as always, left alone)
  const plain = (e) => e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
  FLINKS.forEach((a) => a.addEventListener('click', (e) => { if (!canF || plain(e)) return; e.preventDefault(); setFilter(a.dataset.f); }, on));
  SLINKS.forEach((a) => a.addEventListener('click', (e) => { if (!canS || plain(e)) return; e.preventDefault(); setSort(a.dataset.sort); }, on));

  // a kit named in the link (#mantra, from the home or a caption here):
  // brought to the middle of the screen, it turns round once and back
  function present(el) {
    const r = el.getBoundingClientRect();
    if (r.top < 60 || r.bottom > E.vh - 20) el.scrollIntoView({ block: 'center', behavior: ON ? 'smooth' : 'auto' });
    const o = objOf(el); if (o) o.present();
  }
  // THEME: the address read: the type (its real value, or its key, as the
  // mockup wrote it), the sort; the order the page came in
  function readURL() {
    const q = new URLSearchParams(location.search);
    const fv = (q.get(QF) || '').trim().toLowerCase();
    let f = 'all';
    if (fv) { const hit = TYPES.find((t) => t === fv || String(VAL[t]).toLowerCase() === fv); if (hit) f = hit; }
    return [f, sortOf(q.get(QS) || DEF)];
  }
  const hashOf = () => { try { return decodeURIComponent(location.hash.slice(1)); } catch (e) { return location.hash.slice(1); } };
  function fromURL(first) {
    const h = hashOf();
    if (first) {
      [F, S] = readURL();
      // THEME: Shopify's price-ascending is by a product's lowest version;
      // the cards show their first one (spectra, spectra 2 at 39,99 € came
      // among the 29,99 €): the price is always sorted here, by the price
      // shown, the page's order between equals (as a press on "price")
      S0 = S === 'price' ? '' : S;
      // (the old #type, where the whole table is here)
      if (canF && TYPES.includes(h)) F = h;
      // THEME: several pages: the table is what Shopify sent (the type it
      // filtered on, marked by Liquid), never filtered again on one page
      if (!canS) { const a = FLINKS.find((x) => x.classList.contains('on')); F = a ? a.dataset.f : 'all'; }
      arrange();
    } else if (canF && (TYPES.includes(h) || h === 'all')) { setFilter(h); return; }
    if (h === 'vault') { if (first) later(() => toVault(false), 120); else toVault(true); return; }
    const el = byH.get(h);
    if (!el) return;
    if (el.hidden) { if (!canF) return; F = 'all'; arrange(); keepURL(); if (!first) D.layout(); }
    later(() => present(el), first ? 500 : 0);
  }
  W.addEventListener('hashchange', () => fromURL(false), on);

  // THEME: (a kit pressed opens its page: every kit has one in the store;
  // the mockup's turn on the spot, for kits without a page, is gone)

  // the first layout, from the address; then the kits in view are set
  // out: each stands up from lying flat, one after another — once its
  // cover is there. Until then it waits, unseen, under its caption (never
  // a bare slab on the first screen). Those whose covers come in time
  // stand up together in reading order; a late one on its own, as its
  // cover comes (3.5 s at the latest, then the cover fades in on it).
  fromURL(true);
  D.layout();
  // (the first frame of each is its pose for where it now stands, its
  // line drawn as far: never drawn whole, then taken back)
  if (ON) { ITEMS.forEach((el) => { if (!el.hidden) poseNow(objOf(el)); }); const hk = $('[data-k-pass]', board); poseNow(hk && hk._obj); }
  const imgOf = (el) => $('.kit-face img', el) || $('.kit img', el);
  const hasCover = (el) => { const i = imgOf(el); return !i || (i.complete && i.naturalWidth > 0); };
  const coverIn = (el, ms) => new Promise((res) => {
    const i = imgOf(el);
    if (hasCover(el)) { res(); return; }
    const t = later(res, ms), done = () => { clearTimeout(t); timers.delete(t); res(); };
    i.addEventListener('load', done, { once: true }); i.addEventListener('error', done, { once: true });
  });
  function setOut(el, delay) {
    const waited = el.classList.contains('k-wait'), o = objOf(el), k = $('.kit', el), i = imgOf(el);
    el.classList.remove('k-wait');
    if (!ON) return;
    if (waited && k && k.animate) k.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 420, delay, fill: 'backwards', easing: 'cubic-bezier(.2,.7,.2,1)' });
    if (i && !hasCover(el)) { i.style.opacity = '0'; i.addEventListener('load', () => { i.style.opacity = ''; if (i.animate) i.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 360 }); }, { once: true }); }
    if (o) o.lie(0, 760, delay);
  }
  const T0 = performance.now();
  const firstIn = ITEMS.filter((el) => !el.hidden && inView(el));
  firstIn.forEach((el) => { if (!hasCover(el)) el.classList.add('k-wait'); const o = objOf(el); if (ON && o) o.lie(1); });
  // (every other kit's line waits for its kit, see "the table read off the scroll")
  if (ON) { const fin = new Set(firstIn); ITEMS.forEach((el) => { if (!fin.has(el)) lineIn(el); }); }
  Promise.race([Promise.all(firstIn.map((el) => coverIn(el, 3500))), new Promise((r) => later(r, 700))]).then(() => {
    if (live !== me) return;
    const wait = Math.max(0, 380 - (performance.now() - T0));
    let n = 0;
    firstIn.forEach((el) => { if (hasCover(el)) setOut(el, wait + n++ * 60); });
    firstIn.forEach((el) => { if (el.classList.contains('k-wait')) coverIn(el, 2800).then(() => { if (live === me) setOut(el, 0); }); });
  });
  // a new column count (a phone turned, a window resized) moves the rows
  W.addEventListener('resize', () => { clearTimeout(arrangeT); arrangeT = setTimeout(() => { if (live === me && cols() !== lastCols) { arrange(); D.layout(); } }, 160); }, on);

  // THEME: (2. the vault's key, "get the vault" — [data-vault-add] — is the
  // system's now: drayki.js adds the vault and opens the cart)
  D.layout();
}

// THEME: registered with the system (drayki.js, deferred, has defined
// window.DRAYKI before this module runs); nothing happens without it
if (D && D.section) D.section('kits', init);
